import React from 'react';
import { Card } from './ui/card';
import { Check } from 'lucide-react';
import { aboutData } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="bg-[#0B0B0B] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className="animate-fadeInLeft">
            <span className="text-[#FF3B3B] text-sm font-semibold uppercase tracking-widest mb-4 block">
              About Me
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              {aboutData.title}
            </h2>
            <p className="text-[#9CA3AF] text-lg leading-relaxed mb-8">
              {aboutData.description}
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              {aboutData.highlights.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-[#FF3B3B]/10 flex items-center justify-center flex-shrink-0">
                    <Check size={14} className="text-[#FF3B3B]" />
                  </div>
                  <span className="text-[#9CA3AF] text-sm">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="animate-fadeInRight">
            <Card className="bg-[#111111] border-white/5 p-3 rounded-2xl overflow-hidden group">
              <div className="relative overflow-hidden rounded-xl">
                <img
                  src={aboutData.image}
                  alt="Marcus Steel - Fitness Influencer"
                  className="w-full h-[500px] object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-transparent to-transparent opacity-60" />
                
                {/* Floating Stats Card */}
                <div className="absolute bottom-6 left-6 right-6">
                  <Card className="bg-[#1A1A1A]/90 backdrop-blur-xl border-white/10 p-4 rounded-xl">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-white font-semibold">Industry Experience</p>
                        <p className="text-[#9CA3AF] text-sm">Building communities since 2018</p>
                      </div>
                      <div className="text-3xl font-bold text-[#FF3B3B]">7+</div>
                    </div>
                  </Card>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
